<template>
  <div class="news-page">
    <div class="d-flex mb-3 justify-content-between position-relative">
      <h1 class="h4 primary--text">
        {{ $localT('section') }}
      </h1>
      <div
        v-if="business"
        class="news-detail-page__edit-btn-wrapper"
      >
        <v-progress-circular
          v-if="loading"
          :value="20"
          indeterminate
          color="primary"
          class="loader"
        />
        <v-btn
          color="primary"
          outlined
          large
          class="news-detail-page__edit-button"
          :disabled="true"
          :loading="loading"
          @click="save(true)"
        >
          {{ news.isPublished ? $t('common.published') : $t('common.not_published') }}
        </v-btn>
        <v-btn
          color="primary"
          outlined
          large
          class="news-detail-page__edit-button"
          :to="`/content/edit/${id}/${type}`"
        >
          {{ $t('views.news.edit') }}
        </v-btn>
      </div>
    </div>
    <main class="news-detail-page__main">
      <div class="news-detail">
        <a
          v-if="news.link"
          :href="news.link"
          target="_blank"
          class="news-detail__title"
        >
          {{ news.lead }}
        </a>
        <div
          v-else
          class="news-detail__title"
        >
          {{ isHelp ? news.lead : news.subject }}
        </div>
        <template v-if="isNews">
          <div class="news-detail__lead">
            {{ news.lead }}
          </div>
          <div class="news-detail__date">
            {{ news.date | moment('L') }}
          </div>
        </template>
        <div
          v-if="isSpecialOffer"
          class="news-detail__date"
        >
          Действует с {{ news.startDate | moment('L') }} по {{ news.endDate | moment('L') }}
        </div>
        <img
          v-if="news.image"
          class="news-detail__image"
          :src="news.image.filePath"
          alt=""
        >
        <div v-html="news.content" />
      </div>
    </main>
  </div>
</template>

<script>
import { camelize, contentTypes } from '@/utils/enums';
import { mapGetters } from 'vuex';

export default {
  name: 'NewsPage',
  props: {
    id: String,
    type: String,
  },
  data: () => ({
    news: {},
    loading: false,
  }),
  computed: {
    ...mapGetters(['business']),
    isNews() {
      return this.type === camelize(contentTypes.ref.news);
    },
    isHelp() {
      return this.type === camelize(contentTypes.ref.help);
    },
    isSpecialOffer() {
      return this.type === camelize(contentTypes.ref.specialOffer);
    },
  },
  created() {
    this.getNews();
  },
  methods: {
    $localT(text) {
      return this.$t(`views.${this.type}.${text}`);
    },
    async getNews() {
      this.loading = true;
      const params = {
        populate: 'image',
      };
      const { data } = await this.$http.get(`/content/${this.id}`, { params }).finally(() => {
        this.loading = false;
      });
      this.news = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.news-detail-page {
  &__back {
    display: flex;
    align-items: center;
    color: var(--aurum);
    transition: color 0.3s ease-in-out;

    svg {
      transform: rotate(180deg);
      margin-right: 5px;
      fill: var(--aurum);
      transition: fill 0.3s ease-in-out;
    }

    &:hover {
      color: var(--margaritas);
      text-decoration: none;

      svg {
        fill: var(--margaritas);
      }
    }
  }

  &__main {
    background-color: #fff;
    min-height: calc(100vh - 215px);
    padding: 30px;
  }

  &__wrapper {
    display: grid;
    grid-template-columns: repeat(2, auto);
    column-gap: 20px;
    align-items: center;
  }

  &__edit-button {
    padding: 12px 25px;
    margin: 0px 10px 0px 10px;

    svg {
      fill: var(--black);
      margin-right: 7px;
      transition: fill 0.3s ease-in-out;
    }

    &:hover {
      svg {
        fill: var(--aurum);
      }
    }

    &:active {
      svg {
        fill: #9d6d4c;
      }
    }
  }
}
</style>
